import gql from 'graphql-tag'
import client from '@stores/apollo'
import { FetchResult } from 'apollo-link'
import { IWorkplaceGroup } from '@api/types'

export type IWorkplaceGroups = {
  viewer: {
    company: {
      workplaceGroups: {
        edges: {
          node: IWorkplaceGroup
        }
      }
    }
  }
}

export default function fetchWorkPlaceGroups(): Promise<FetchResult<IWorkplaceGroups>> {
  return client.gql.query({ query })
}

const query = gql`
  query Company {
    viewer {
      company {
        workplaceGroups {
          edges {
            node {
              name
              id
              color
            }
          }
          counters {
            total
          }
        }
      }
    }
  }
`
